import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriversDHTLimits } from '../../services/DriversService';
import { DHTLimitsResponse } from '../../types/Drivers';

function useGetDHTLimitsPerFleet(fleetId: string): UseQueryResult<DHTLimitsResponse> {
  return useQuery(
    ['drivers-dht', fleetId],
    async (): Promise<DHTLimitsResponse> => getDriversDHTLimits(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetDHTLimitsPerFleet;
